import React from 'react';

/**
 * IB-701 — shared dashed "+ New …" tile used by both the Setup > Categories and Setup > Policy
 * grids. Matches the height/rounding of the real tiles so the grid stays even. Colours come from
 * tailwind.config.js.
 */
const NewTile = ({ label, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className="tw-flex tw-min-h-[7.5rem] tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-rounded-lg tw-border-2 tw-border-dashed tw-border-grey tw-bg-white tw-text-charcoal-50 tw-transition-colors hover:tw-border-blue-25 hover:tw-text-blue"
    >
        <span className="tw-text-2xl tw-leading-none">+</span>
        <span className="tw-text-sm tw-font-medium">{label}</span>
    </button>
);

export default NewTile;
